module.exports = __webpack_public_path__ + "static/Slide03@3x.f941b30f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/events/new/Slide03@3x.png
// module id = 710
// module chunks = 216210090109534